
import { Component, Mixins } from "vue-property-decorator";
import { Patient } from "../../../../domain/patient";
import { SelectorDialogMixin } from "../../../system";

@Component
export default class DuplicatedPatientSelectorDialogMixin extends Mixins(SelectorDialogMixin) {
  data() {
    return {
      sourceId: null as string,
    };
  }
  sourceId: string;
  
  get title(): string {
    return "重複ID一覧";
  }

  get isOtherIdSelected(): boolean {
    return !!this.selected && (this.selected.id !== this.sourceId);
  }

  async selectOption(source: Patient): Promise<Patient> {
    this.sourceId = source.id;
    return this.show<Patient>(null);
  }

  selectPatient(patient: Patient): void {
    this.selected = patient;
    if (this.isOtherIdSelected) {
      this.select();
    }
  }
}
